import React, { ReactElement } from 'react'
import { useRecoilValue } from 'recoil'
import { isActiveCourseReadOnlySelector } from '@/atoms/auth'
import { Button } from 'antd'
import { PlusCircleOutlined } from '@ant-design/icons'

interface AddFormulaSheetEntryButtonProps {
    // Adds into the currently open group (falls back to Unassigned) — the
    // editor owns that state, so the behavior is injected
    onAdd: () => void
}

export const AddFormulaSheetEntryButton: React.FC<
    AddFormulaSheetEntryButtonProps
> = (props): ReactElement => {
    const isReadOnly = useRecoilValue(isActiveCourseReadOnlySelector)
    return (
        <Button
            onClick={props.onAdd}
            icon={<PlusCircleOutlined />}
            disabled={isReadOnly}
        >
            Add formula
        </Button>
    )
}
